// src/components/WatchlistButton.js
import React, { useState, useEffect } from 'react';
import { useUser } from '../UserContext';
import { fetchWatchlist, addToWatchlist, removeFromWatchlist } from '../services/watchlistService';

const WatchlistButton = ({ symbol, companyName, exchange }) => {
  const { userEmail } = useUser();
  const [isWatched, setIsWatched] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!userEmail || !symbol) return;
    fetchWatchlist(userEmail)
      .then((data) => {
        const inList = data.items?.some((item) => item.symbol === symbol);
        setIsWatched(inList);
      })
      .catch(() => {});
  }, [userEmail, symbol]);

  const handleToggle = async () => {
    if (!userEmail || !symbol) return;
    setLoading(true);
    setError('');
    try {
      if (isWatched) {
        await removeFromWatchlist(userEmail, symbol);
        setIsWatched(false);
      } else {
        await addToWatchlist(userEmail, symbol, companyName, exchange);
        setIsWatched(true);
      }
    } catch (err) {
      setError(err.message);
      setTimeout(() => setError(''), 3000);
    } finally {
      setLoading(false);
    }
  };

  if (!userEmail) return null;

  return (
    <div className="inline-flex items-center gap-1">
      <button
        onClick={handleToggle}
        disabled={loading}
        className={`text-lg transition-all ${loading ? 'opacity-50' : 'hover:scale-110'} ${
          isWatched ? 'text-amber-400' : 'text-gray-300 hover:text-amber-300'
        }`}
        title={isWatched ? 'Remove from watchlist' : 'Add to watchlist'}
        aria-label={isWatched ? 'Remove from watchlist' : 'Add to watchlist'}
      >
        {isWatched ? '★' : '☆'}
      </button>
      {error && (
        <span className="text-[10px] text-red-500 max-w-[120px] truncate">{error}</span>
      )}
    </div>
  );
};

export default WatchlistButton;
